import { ApiResourceMethod } from '@/api/api-requests-factory';
import { BaseResponse } from '@/api/api-requests-factory/models/response.model';
import { TopListRequestDateParameters } from '@/models/top-list/top-list-request-date-parameters.model';
import { TopWinListResponse } from '@/models/top-list/top-win-list-response.model';
import { TopWinListItem } from '@/models/top-list/top-win-list.model';
import { clearObj } from '@marfa/bo-utils';

export default class GetTopWinListRequest extends ApiResourceMethod<TopWinListResponse> {
  public perform(whitelabelSlug: string, requestPayload: TopListRequestDateParameters): Promise<TopWinListResponse> {
    return this.performer.requestWithMapper(
      {
        url: `${whitelabelSlug}/report/gameRound`,
        params: clearObj(requestPayload),
      },
      ({ headers, data }: BaseResponse<TopWinListItem[]>): TopWinListResponse => ({
        data,
        headers,
      }),
    );
  }
}
